import { AlertTriangle, Instagram } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { IG_PROFILE } from "../lib/api";

export function LicenseBanner() {
  const { user } = useAuth();
  if (!user || user.role === "superadmin" || user.days_left > 30) return null;
  const expired = !user.license_active;
  return (
    <div
      data-testid="license-warning-banner"
      className={`flex flex-col gap-3 rounded-2xl border px-4 py-3 sm:flex-row sm:items-center sm:justify-between ${
        expired ? "border-rose-300 bg-rose-50 text-rose-800" : "border-amber-300 bg-amber-50 text-amber-900"
      }`}
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0" />
        <p className="text-sm">
          {expired ? (
            <b>Lisans süreniz doldu.</b>
          ) : (
            <>
              Lisansınızın bitmesine <b data-testid="license-days-left">{user.days_left} gün</b> kaldı.
            </>
          )}{" "}
          Yenileme için Instagram'da <b>@kasamnetcom</b> hesabına mesaj gönderin.
        </p>
      </div>
      <a
        data-testid="license-instagram-link"
        href={IG_PROFILE}
        target="_blank"
        rel="noreferrer"
        className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-gradient-to-r from-pink-500 via-fuchsia-500 to-orange-400 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-transform active:scale-95"
      >
        <Instagram className="h-4 w-4" /> Mesaj Gönder
      </a>
    </div>
  );
}
